import $ from "jquery";
import validate from "jquery-validation";
import './jquery-validate-extra-rules';

export function init() {
    const submitBtn = document.querySelector('.js-newsletter-submit'),
        results = document.querySelector('.js-newsletter-results'),
        rules = {
            'first_name': {
                required    : true,
                minlength   : 2
            },
            'last_name': {
                required    : true,
                minlength   : 2
            },
            'email_address': {
                required    : true,
                email       : true
            },
            'consent': {
                required    : true
            }
        },
        messages = {
            'first_name': {
                required    : 'Please provide your first name',
                minlength   : 'Please provide your full first name'
            },
            'last_name': {
                required    : 'Please provide your last name',
                minlength   : 'Please provide your full last name'
            },
            'email_address': {
                required    : 'Please provide your email address',
                email       : 'Please provide a valid email address'
            },
            'consent': {
                required    : 'You must give consent for WEC to store your details and email you regular updates'
            }
        };

    // Setup form validation and submision events
    $('.js-newsletter').validate({
        rules           : rules,
        messages        : messages,
        errorPlacement: function($error, $el) {
            // If this is a checkbox
            if ($el.is('[type=checkbox]')) {
                // Check for a group container
                var $checkboxGroupContainer = $el.closest('.js-checkbox-container');

                if ($checkboxGroupContainer.length) {
                    return $checkboxGroupContainer.append($error);
                }
            }

            return $error.insertAfter($el);
        },
        submitHandler: function (form) {
            // Update submit button text
            submitBtn.classList.add('sending');
            submitBtn.value = 'Subscribing...';

            const formData = new FormData(form);

            fetch(form.action, {
                method: 'POST',
                headers: { 
                    "X-Requested-With": "XMLHttpRequest" 
                },
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                if (data) {
                    if (data.status == 'success') {
                        form.querySelectorAll('input:not([type="checkbox"]):not([type="submit"]), textarea').forEach(el => {
                            el.value = '';
                        });

                        submitBtn.classList.remove('sent');
                        submitBtn.value = 'Subscribed';

                        // Fire an event off to Google Analytics to track this form submission
                        if (typeof ga !== "undefined") {
                            ga('send', {
                                hitType: 'event',
                                eventCategory: 'Newsletter',
                                eventAction: 'Signup'
                            });
                        }
                    } else {
                        submitBtn.classList.remove('sending');
                        submitBtn.value = 'Sign up';
                    }

                    results.innerHTML = data.message;
                    results.classList.add(data.status);
                } else {
                    results.innerHTML = '<p>Sorry there was a problem with your registration. Please check your email address and try again.</p>';
                    submitBtn.classList.remove('sending');
                    submitBtn.value = 'Sign up';
                }
            });
        }
    });
}